class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Expand top-level menu items on hover for desktop pointer devices.
    // Touch/coarse-pointer devices keep the default click-to-toggle behavior.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.closeTimer = null;

      // Cancel any pending close and open immediately on hover.
      this.addEventListener('mouseenter', () => {
        clearTimeout(this.closeTimer);
        this.open();
      });

      // Delay closing so the cursor can cross the gap between the menu item
      // and the dropdown panel without the menu disappearing. Re-entering
      // either the label or the panel cancels the close above.
      this.addEventListener('mouseleave', () => {
        clearTimeout(this.closeTimer);
        this.closeTimer = setTimeout(() => this.close(), 200);
      });

      // Prevent a mouse click on the summary from immediately collapsing the
      // menu that hover just opened. Keyboard activation (detail === 0) is
      // left untouched so the menu stays accessible.
      this.mainDetailsToggle.querySelector('summary').addEventListener('click', (event) => {
        if (event.detail !== 0) event.preventDefault();
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
